<template>
    <div class="eventsurvey">
        <Header/>

        <div class="eventsurveycontainer">
            <!-- Web Survey Begin -->
            <iframe src="./survey.html" frameborder="0"></iframe>

            <div class="more">
                <h1>For more questions related to the Gartner Peer Insights survey,
                
                <a><router-link to="/gartnerfaq">click here.</router-link></a>

                or contact us at 
                
                <a href="PIreviews@veeam.com">PIreviews@veeam.com</a>
            
                </h1>

                <img :src="GartnerPeerInsightsLogo" class="bottomlogo">
            </div>
        </div>
    </div>
</template>





<script>

    import Header from "../components/Header.vue";
    import GartnerPeerInsightsLogo from "../assets/GartnerPeerInsightsLogo.png";

    export default {
        name: "EventSurvey",
        components: {
            Header
        },
        data () {
            return {
                GartnerPeerInsightsLogo
            }
        }
    }

</script>


<style scoped>

    .eventsurveycontainer {
        padding: 20px;
        margin: 0;
        width: 100%;
        height: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
    }

    iframe {
        height: 85vh;
        width: 700px;
        padding: 10px;
    }

    .more {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
    }

    .more h1 {
        font-family: guardianfont;
        font-weight: 500;
        letter-spacing: 0.3px;
        font-size: 20px;
        color: #636363;
        text-align: center;
    }

    a {
        text-decoration: none;
        color: #00b336;
    }

    .bottomlogo {
        width: 50%;
    }



     /* Desktop to Mobile Break */
    @media only screen and (max-width: 800px) {

        iframe {
            height: 85vh;
            width: 100%;
            padding: 10px;
        }

    }

</style>